<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        max-width="370"
    >
      <v-card>
        <v-card-title class="headline">{{deleteForm.header}}</v-card-title>

        <v-card-text>
          {{deleteForm.content}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            outlined
            @click="dialog = false"
          >
            {{ $vuetify.lang.t('$vuetify.deleteModal.cancel') }}
          </v-btn>

          <v-btn
            color="primary"
            @click="submitDeleteDevice()"
          >
            {{ $vuetify.lang.t('$vuetify.deleteModal.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    data () {
        return {
            dialog: false
        }
    },
    props: {
        deleteForm: {
            type: Object,
            default: null
        }
    },
    methods: {
        async submitDeleteDevice () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.delete(this.deleteForm.path)
            if (res && res.status === 200 && res.data && res.data.status !== 'error' && res.data.status !== 'error_inputs') {
                this.$emit('success-deleted')
                this.dialog = false
                this.$store.dispatch('setLoading', false)
            } else if (res && res.status === 200 && res.data && res.data.status === 'error_inputs') {
                const errors = res.data.errors
                for (const property in errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.companyProfile.errorMessage'),
                        text: errors[property],
                        type: 'error'
                    })
                }
                this.dialog = false
                this.$store.dispatch('setLoading', false)
            }
        }
    }
}
</script>
